import { SubmitButton } from "components/common/buttons/SubmitButton";
import ErrorMessage from "components/common/ErrorMessage";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Api from "services/api";

const RejectSubmissionModal = ({
  isOpen,
  onClose,
  onConfirm,
  transId,
  callViewApi,
}) => {
  const methods = useForm();
  // const [status, setStatus] = useState(false);

  const [isloading, setIsloading] = useState(false);

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = methods;

  useEffect(() => {
    methods.reset({ cancel_reason: "" });
  }, [isOpen, methods]);

  const rejectSubmission = async (data) => {
    const payload = new FormData();
    payload.append("reason", data.cancel_reason);

    try {
      setIsloading(true);
      if (transId) {
        const response = await Api.translationRejectSubmission(
          transId,
          payload
        );
        toast.success(response?.data?.message, {
          className: "successToast",
        });
        // setStatus(response?.data?.success);
        if (response?.data?.success) {
          callViewApi(transId);
        }
        if (onConfirm) onConfirm(data, "cancel");
        onClose();
      } else {
        console.warn("transId is missing or invalid.");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsloading(false);
    }
  };

  // useEffect(() => {
  //   callViewApi();
  // }, [status]);

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
      <form onSubmit={handleSubmit(rejectSubmission)}>
        <ModalHeader className="header_modal align-items-center">
          <h5 className="modal-title_u">Reject Submission</h5>
        </ModalHeader>
        <ModalBody className="modal_form_body">
          <div
            style={{
              backgroundColor: "#F2F2F2",
              padding: "10px",
              borderRadius: "8px",
            }}
            className="min-height-auto"
          >
            <div className="row-primary">
              <h2>Reason</h2>
              <Controller
                name="cancel_reason"
                control={control}
                rules={{
                  required: "Please write reason",
                }}
                render={({ field }) => (
                  <>
                    <textarea
                      className="type_inp input-in"
                      {...field}
                      placeholder="Write reason for Cancel ..."
                      required
                    ></textarea>

                    {errors?.cancel_reason?.message && (
                      <ErrorMessage text={errors?.cancel_reason?.message} />
                    )}
                  </>
                )}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <SubmitButton
            btnText={isloading ? "Loading..." : "Reject Submission"}
            buttonType="button"
            handleSubmit={handleSubmit(rejectSubmission)}
            loader={isloading}
          />
          <button className="Cancle_button" type="button" onClick={onClose}>
            Close
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default RejectSubmissionModal;
